import { IEvent, createConsumer, createSubscriber } from '@cian/events-log';

import type { AnyAction } from 'redux';
import type { ThunkAction } from 'redux-thunk';

import { IAppState, IThunkExtraArgument } from '../../common/state';
import { EAlertType } from '../../types/microfrontends';

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
  /**
   * Вызывается после успешной авторизации. Если не передан — страница перезагружается
   */
  onSuccess?(): void;
}

/**
 * Открывает модалку авторизации через API микрофронтенда шапки
 */
export function requestAuthentication({ alert, onSuccess }: IRequestAuthenticationParameters = {}): ThunkAction<
  void,
  IAppState,
  IThunkExtraArgument,
  AnyAction
> {
  return (_dispatch, _getState, { microfrontendsAPI }) => {
    if (!microfrontendsAPI) {
      return;
    }

    if (onSuccess) {
      const consumer = createConsumer({ topic: 'user' });
      const userSubscriber = createSubscriber((event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          onSuccess();
          consumer.destroy();
        }
      });

      consumer.subscribe(userSubscriber);
    }

    void microfrontendsAPI.header.openAuthModal({
      autoRefresh: !onSuccess,
      alert: alert ?? null,
      useDefaultView: false,
      viewData: null,
      source: null,
    });
  };
}
